import { NODE_ENV, PLATFORM_ENV } from '../types/environment';

/**
 * get asset url i.e. cdn public url or dashboard public url
 * @param env
 * @returns
 */
export const getAssetUrl = ({
  CDN_PUBLIC_URL: cdnHost,
  DASHBOARD_PUBLIC_URL: dashboardPublicURL,
  VERSION: version,
  PLATFORM_ENV: platformEnv,
  NODE_ENV: nodeEnv,
}: {
  CDN_PUBLIC_URL: string;
  DASHBOARD_PUBLIC_URL: string;
  NODE_ENV: string;
  PLATFORM_ENV: string;
  VERSION: string;
}): string => {
  if (cdnHost && nodeEnv === NODE_ENV.PRODUCTION && platformEnv !== PLATFORM_ENV.ENTERPRISE) {
    return `${cdnHost}/${version}/dashboard/public`;
  }

  return dashboardPublicURL;
};
